<template>
	<div>
		<vx-card
			no-shadow
			card-border
			class="custom-height"
			:title="$t('Vehicles.AssignedVehicles') + ' ' + assignedVehicles.length"
		>
			<template v-if="showActions" slot="actions">
				<div class="flex flex-row justify-between">
					<vx-tooltip
						class="cursor-pointer"
						color="primary"
						position="bottom"
						delay=".1s"
						:title="$t('Vehicles.AssignVehicles')"
						:text="$t('Vehicles.AssignVehicleToltip')"
					>
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-plus"
							@click="vehicleMounted = true"
						></vs-button>
					</vx-tooltip>
					<vx-tooltip
						class="cursor-pointer"
						color="primary"
						position="bottom"
						delay=".1s"
						:title="$t('Vehicles.Vehicle')"
						:text="$t('Vehicles.DeleteAllVehicles')"
					>
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-trash"
							@click.stop="deleteAll"
							v-show="assignedVehicles.length > 0"
						></vs-button>
					</vx-tooltip>
					<vs-dropdown vs-custom-content :vs-trigger-click="false" class="cursor-pointer">
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-layout"
						></vs-button>
						<vs-dropdown-menu style="width: 30%">
							<vx-card no-shadow :title="$t('AssignedTeams.Columns')">
								<p>{{ $t("AssignedTeams.ColumnsText") }}</p>
								<ul class="demo-alignment">
									<li>
										<vs-checkbox v-model="checkBoxID" disabled>ID</vs-checkbox>
									</li>
									<li>
										<vs-checkbox v-model="checkBoxProfile">{{ $t("Profile") }}</vs-checkbox>
									</li>
									<li>
										<vs-checkbox v-model="checkBoxIdentification">{{
											$t("ResourceModule.Table.Identification")
										}}</vs-checkbox>
									</li>
									<li>
										<vs-checkbox v-model="checkBoxStartDeposit">{{
											$t("StartDeposit")
										}}</vs-checkbox>
									</li>
									<li>
										<vs-checkbox v-model="checkBoxEndDeposit">{{ $t("EndDeposit") }}</vs-checkbox>
									</li>
								</ul>
							</vx-card>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>
			</template>
			<vue-perfect-scrollbar class="scroll-area" :settings="settings">
				<vs-table
					v-if="assignedVehicles.length > 0"
					:max-items="componentParent === 'SKILLS' || componentParent === 'CAPACITY' ? '1000' : '6'"
					:data="assignedVehicles"
					:search="search"
					:pagination="pagination"
				>
					<template slot="thead">
						<vs-th>ID</vs-th>
						<vs-th v-show="checkBoxProfile">{{ $t("Profile") }}</vs-th>
						<vs-th v-if="isDemand">{{ $t("Capacity.Capacity") }}</vs-th>
						<vs-th v-show="checkBoxIdentification">{{ $t("ResourceModule.Table.Identification") }}</vs-th>
						<vs-th v-show="checkBoxStartDeposit">{{ $t("StartDeposit") }}</vs-th>
						<vs-th v-show="checkBoxEndDeposit">{{ $t("EndDeposit") }}</vs-th>
						<vs-th>{{ $t("ResourceModule.Table.Actions") }}</vs-th>
					</template>
					<template slot-scope="{data}">
						<vs-tr :key="indextr" v-for="(tr, indextr) in data">
							<vs-td v-show="checkBoxID" :data="data[indextr].id">
								{{ data[indextr].id }}
							</vs-td>
							<vs-td v-show="checkBoxIdentification" :data="data[indextr].id">
								{{ chipText(data[indextr].profile) }}
							</vs-td>
							<vs-td v-if="isDemand" :data="data[indextr].id">
								<span v-if="!data[indextr].isEditDemand" @click.prevent="editCellDemand(data[indextr])">
									<span style="padding-left: 4px; margin-right: 10px">{{
										data[indextr].demand
									}}</span>
									<span :title="$t('Edit')" style="height: 30px">🖉</span>
								</span>
								<div v-else>
									<vs-input
										v-model="data[indextr].demand"
										type="number"
										ref="inputDemand"
										@keydown="onKeyDown($event, data[indextr])"
									/>
								</div>
							</vs-td>
							<vs-td v-show="checkBoxIdentification" :data="data[indextr].id">
								{{ data[indextr].identification }}
							</vs-td>
							<vs-td v-show="checkBoxStartDeposit" :data="data[indextr].id">
								{{ data[indextr].init_depot_name }}
							</vs-td>
							<vs-td v-show="checkBoxEndDeposit" :data="data[indextr].id">
								{{ data[indextr].end_depot_name }}
							</vs-td>
							<vs-td :data="data[indextr].id">
								<feather-icon
									v-if="remove"
									:title="$t('Crud.Delete')"
									size="small"
									icon="TrashIcon"
									svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
									@click="removeAssignedVehicle(data[indextr])"
								/>
								<feather-icon
									v-if="redirect"
									:title="$t('View') + ' ' + $t('Information')"
									size="small"
									icon="ExternalLinkIcon"
									svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
									class="ml-2"
									@click="goToVehicle(data[indextr].id)"
								/>
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>
				<p v-else>
					{{ $t("Vehicles.NoAssignedVehicles") }}
				</p>
			</vue-perfect-scrollbar>
		</vx-card>
		<vs-popup
			:fullscreen="true"
			:title="$t('Vehicles.ListOfVehicles')"
			:active.sync="vehicleMounted"
			class="vs-popup--content-custom"
		>
			<div class="is-stuck stuck-content" style="background: white">
				<div class="flex items-center justify-end mt-4">
					<div class="flex items-center justify-between">
						<div v-if="isDemand">
							<vs-dropdown
								v-if="getCheckedVehicles.length > 0"
								vs-custom-content
								vs-trigger-click
								class="cursor-pointer"
								:title="$t('ResourceModule.MassiveActionsResource')"
							>
								<vs-button icon-pack="feather" icon="icon-settings">
									{{ windowWidth > 620 ? $t("BreakTable.Action") : null }}
									<vs-icon class="" icon="expand_more"></vs-icon>
								</vs-button>
								<vs-dropdown-menu>
									<div class="p-2">
										<h5>{{ $t("Crud.Update") + " " + $t("Vehicles.Vehicles") }}</h5>
										<vs-input
											:label="$t('Capacity.Capacity')"
											v-model="amount"
											class="w-full mb-2"
											type="number"
											ref="inputDemand"
											@keydown="onKeyDown($event)"
										/>
										<div class="flex justify-end">
											<vs-button
												color="success"
												type="border"
												@click.prevent="updateDemand(amount)"
											>
												{{ $t("Apply") }}
											</vs-button>
										</div>
									</div>
								</vs-dropdown-menu>
							</vs-dropdown>
						</div>
						<div class="flex justify-end">
							<vs-button
								:size="iconSize"
								class="ml-2"
								icon-pack="feather"
								icon="icon-check"
								:title="$t('VisitPoints.Assig') + ' ' + $t('Routing.Title.Selection')"
								:disabled="getCheckedVehicles.length <= 0"
								@click.prevent="setAssignedVehicle"
								>{{
									windowWidth > 620
										? $t("VisitPoints.Assig") + " " + $t("Routing.Title.Selection")
										: null
								}}
							</vs-button>
						</div>
					</div>
				</div>
			</div>
			<vehicle-list
				v-if="vehicleMounted"
				ref="VehicleListPopup"
				style="margin-top: 30px"
				:componentParent="'VEHICLE_ASSIGNED'"
				:customConfig="vehicleListConfig"
			/>
		</vs-popup>
	</div>
</template>

<script>
import vSelect from "vue-select";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VisitPointList from "@/components/visit-point/list/VisitPointList.vue";
import VehicleList from "@/components/vehicle/list/VehicleList.vue";

const KEY_BACKSPACE = "Backspace";
const KEY_F2 = "F2";
const KEY_ENTER = "Enter";
const KEY_TAB = "Tab";
const KEY_ESC = "Escape";
export default {
	props: {
		vehicle_ids: {
			type: Array,
			default: () => [],
		},
		search: {
			type: Boolean,
			default: false,
		},
		pagination: {
			type: Boolean,
			default: false,
		},
		capacitiesVehicle: {
			type: Array,
			default: () => [],
		},
		isDemand: {
			type: Boolean,
			default: true,
		},
		componentParent: {
			type: String,
			default: "VEHICLE_ASSIGNED",
		},
		remove: {
			type: Boolean,
			default: () => true,
		},
		redirect: {
			type: Boolean,
			default: () => false,
		},
		showActions: {
			type: Boolean,
			default: () => true,
		},
	},
	components: {
		vSelect,
		VuePerfectScrollbar,
		VisitPointList,
		VehicleList,
	},
	data() {
		return {
			vehicleMounted: false,
			activeItem: 0,
			visit_point_nav: 0,
			visit_point_selected: [],
			searchField: {value: "Name", label: this.$t("Name")},
			checkBoxProfile: true,
			checkBoxIdentification: true,
			checkBoxStartDeposit: false,
			checkBoxEndDeposit: false,
			checkBoxID: true,
			valCellOldDemand: 0,
			activeSelectVehicle: "0",
			amount: 0,
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			vehicleListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				columns: [
					"id",
					"identification",
					"demand",
					"profile",
					"max_travel_distance",
					"max_travel_duration",
					"init_depot_name",
					"end_depot_name",
				],
				actionDropdown: false,
				activeHeaderCheckboxSelection: true,
				tableOptions: true,
				showItemsPerPage: false,
				showPopup: true,
				showButtonAdd: false,
				showButtonSelected: false,
				CellRendererDemand: this.isDemand,
			},
		};
	},
	computed: {
		assignedVehicles() {
			if (this.capacitiesVehicle && this.capacitiesVehicle.length > 0 && (this.isDemand || this.isTypeService)) {
				for (let vehicle of this.$store.state.vehicle.assignedVehicles) {
					for (let capacity of this.capacitiesVehicle) {
						if (capacity.vehicle_id === vehicle.id) {
							vehicle.demand = capacity.amount;
							vehicle.typeService = capacity.job_type;
						}
					}
				}
			}
			return this.$store.state.vehicle.assignedVehicles;
		},
		getCheckedVehicles() {
			return this.$store.state.vehicle.checkedVehicles === undefined ||
				this.$store.state.vehicle.checkedVehicles === "" ||
				this.$store.state.vehicle.checkedVehicles === null
				? []
				: this.$store.state.vehicle.checkedVehicles;
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		chipText() {
			return (value) => {
				if (value === "car") return this.$t("Routing.Car");
				else if (value === "walk") return this.$t("Routing.Walking");
				else if (value === "bicycle") return this.$t("Routing.Bicycle");
				else if (value === "motorcycle") return this.$t("Routing.Motorcycle");
				else if (value === "truck") return this.$t("Routing.Truck");
				else if (value === "scooter") return this.$t("Routing.Scooter");
				else if (value === "bus") return this.$t("Routing.Bus");
				else if (value === "unknown") return this.$t("NotSpecified");
				else return "";
			};
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getAssignedVehicles() {
			this.openLoading();
			const data = {
				id: this.vehicle_ids.map((id) => Number(id)),
				fields: ["id", "identification"],
				assign: true,
			};
			this.$store
				.dispatch("vehicle/findVehiclePaginated", data)
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		showPopup() {
			this.vehicleMounted = false;
		},
		removeAssignedVehicle(data) {
			this.$store.commit("vehicle/REMOVE_ASSIGNED_VEHICLE", data.id);
		},
		refreshVehicle() {
			this.getAssignedVehicles(1);
		},
		deleteAll() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("VisitPoints.DeleteAllText") + ` "${this.$t("Vehicles.Vehicles")}"`,
				accept: this.deleteAllVehicles,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteAllVehicles() {
			this.$store.commit("vehicle/REMOVE_ALL_ASSIGNED_VEHICLE");
		},
		setAssignedVehicle() {
			let selectedRowsVehicle = [...this.getCheckedVehicles];
			if (selectedRowsVehicle.length > 0) this.$store.commit("vehicle/SET_ASSIGNED_VEHICLE", selectedRowsVehicle);
			this.vehicleMounted = false;
		},
		editCellDemand(data) {
			this.valCellOldDemand = data.demand;
			data.isEditDemand = true;
		},
		updateDemand(amount) {
			if (
				amount !== undefined &&
				amount !== null &&
				amount !== "" &&
				amount > 0 &&
				this.activeSelectVehicle === "0"
			) {
				this.$refs.VehicleListPopup.updateDemand(amount);
				this.amount = "";
			}
			if (
				amount !== undefined &&
				amount !== null &&
				amount !== "" &&
				amount > 0 &&
				this.activeSelectVehicle === "1"
			) {
				this.$refs.VehicleListPopup.updateDemand(amount);
				this.amount = "";
			}
		},
		onKeyDown(event, val) {
			if (this.isLeftOrRight(event) || this.isBackspace(event)) {
				event.stopPropagation();
				return;
			}
			if (this.isEsc(event)) {
				val.demand = this.valCellOldDemand;
				val.isEditDemand = false;
			}
			if (!this.finishedEditingPressed(event) && !this.isKeyPressedNumeric(event)) {
				if (event.preventDefault) event.preventDefault();
			} else if (this.finishedEditingPressed(event)) {
				val.isEditDemand = false;
			}
		},
		isCharNumeric(charStr) {
			return /\d/.test(charStr);
		},
		isKeyPressedNumeric(event) {
			const charStr = event.key;
			return this.isCharNumeric(charStr);
		},
		finishedEditingPressed(event) {
			const key = event.key;
			return key === KEY_ENTER || key === KEY_TAB;
		},
		isBackspace(event) {
			return event.key === KEY_BACKSPACE;
		},
		isEsc(event) {
			return event.key === KEY_ESC;
		},
		isLeftOrRight(event) {
			return ["ArrowLeft", "ArrowRight"].indexOf(event.key) > -1;
		},
		goToVehicle(vehicleId) {
			this.$router.push(`/apps/vehicle/vihicle-view/${vehicleId}`);
		},
	},
	created() {
		if (this.vehicle_ids && this.vehicle_ids.length > 0 && this.getAssignedVehicles.length <= 0) {
			this.getAssignedVehicles();
		}
	},
	beforeDestroy() {
		this.deleteAllVehicles();
	},
};
</script>

<style lang="scss" scoped>
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 400px;
	max-height: 450px;
}
.content-form-create {
	width: 100%;
	min-height: 550px;
	max-height: 650px;
}
.is-stuck {
	position: fixed;
	top: 52px;
	inset-inline-start: 0;
	margin-inline-start: 30px;
	width: calc(100% - 80px);
	z-index: 14;
}
.form-header-inner {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}
.con-vs-dropdown--menu {
	z-index: 54000 !important;
}
</style>
<style lang="scss">
.stuck-content .vs-con-items {
	border: 1px #ccc solid;
}
</style>
